import React from 'react';
import '../styles/ContactFooter.css';

const socialPlatforms = [
  {
    name: 'WhatsApp',
    description: 'Quick Chat',
    icon: 'fab fa-whatsapp',
    color: '#25d366',
    url: 'https://wa.me/918148353564'
  },
  {
    name: 'Website',
    description: 'Learn More',
    icon: 'fas fa-globe',
    color: '#2563eb',
    url: 'https://www.eksconstruction.in'
  },
  {
    name: 'Call Us',
    description: 'Direct Support',
    icon: 'fas fa-phone-alt',
    color: '#10b981',
    url: 'tel:+918148353564'
  },
  {
    name: 'Email',
    description: 'Send us a message',
    icon: 'fas fa-envelope',
    color: '#ea4335',
    url: 'mailto:eksconstruction30@gmail.com'
  },
  {
    name: 'Instagram',
    description: 'Visual Stories',
    icon: 'fab fa-instagram',
    color: '#e4405f',
    url: 'https://www.instagram.com/eks_construction?igsh=MXdudGk5ZzQweGM1OQ=='
  },
  {
    name: 'YouTube',
    description: 'Video Content',
    icon: 'fab fa-youtube',
    color: '#ff0000',
    url: 'https://youtube.com/@eksconstructions?si=qVlYdvO0-7JaDtun'
  }
];

function SocialCard({ platform }) {
  return (
    <a
      href={platform.url}
      target={platform.url.startsWith('mailto:') || platform.url.startsWith('tel:') ? '_self' : '_blank'}
      rel="noopener noreferrer"
      className="social-card"
    >
      <div className="social-card-icon" style={{ backgroundColor: platform.color }}>
        <i className={platform.icon}></i>
      </div>
      <h3 className="social-card-title">{platform.name}</h3>
      <p className="social-card-desc">{platform.description}</p>
      <span className="social-card-link">
        Connect <span className="arrow">→</span>
      </span>
    </a>
  );
}

function ContactFooter() {
  return (
    <div className="contact-footer-wrapper">
      {/* Contact Section */}
      <section id="contact" className="contact-section">
        <div className="contact-container">
          {/* Badge */}
          <span className="contact-badge">Connect & Collaborate</span>

          {/* Title */}
          <h2 className="contact-title">Get In Touch</h2>

          {/* Subtitle */}
          <p className="contact-subtitle">
            Join our vibrant community and stay connected with the latest updates on your construction projects
          </p>

          {/* Social Cards Grid */}
          <div className="social-cards-grid">
            {socialPlatforms.map((platform, index) => (
              <SocialCard key={index} platform={platform} />
            ))}
          </div>
        </div>
      </section>

      {/* Footer Copyright */}
      <footer className="footer-copyright">
        <p>
          &copy; 2024 EKS Construction. All rights reserved. | Chennai's Most Trusted Construction Partner
        </p>
      </footer>
    </div>
  );
}

export default ContactFooter;